import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import moment from 'moment';

interface IVoidVoucherDialogProps {
    dialogName: string;
    voidType: 'Voucher' | 'Check';
    checkNumber: number;
    voucherNumber: number;
    handleVoid?: (date: Date, voidBy: string, reason: string) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
}

const VoidVoucherDialog = (props: IVoidVoucherDialogProps) => {
    const { register, errors, getValues } = useForm();
    const appContext = React.useContext<IAppContextState>(AppContext);

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('VoidVoucherDialog onCreate()');
    };

    const OKClicked = () => {
        let data = getValues();
        console.log('OK Clicked', data);

        props.handleVoid(new Date(), data.voidBy, data.reason);
        props.hideDialog();
    };

    return (
        <Dialog title={`Void ${props.voidType}`} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '50%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <div className="form-row" style={{ marginTop: '3rem' }}>
                        <RHFInputBox
                            label="Voucher No."
                            labelOnLeft={true}
                            labelStyle={{ width: '15rem' }}
                            name={`voucherNumber`}
                            defaultVal={props.voucherNumber + ''}
                            type="number"
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            disabled={true}
                        />
                        <RHFInputBox
                            label="Check No."
                            labelOnLeft={true}
                            labelStyle={{ width: '15rem' }}
                            name={`checkNumber`}
                            defaultVal={props.checkNumber + ''}
                            type="number"
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            disabled={true}
                        />
                    </div>
                    <div className="form-row">
                        <RHFInputBox
                            label="Void Date"
                            labelOnLeft={true}
                            labelStyle={{ width: '15rem' }}
                            name={`voidDate`}
                            defaultVal={moment(new Date()).format('MM/DD/YYYY h:mm a') as unknown as Date + ''}
                            type="text"
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            disabled={true}
                        />
                        <RHFInputBox
                            label="Void By"
                            labelOnLeft={true}
                            labelStyle={{ width: '15rem' }}
                            name={`voidBy`}
                            defaultVal={appContext.currentUser.username}
                            type="text"
                            register={register}
                            errors={errors}
                            style={{ width: '100%' }}
                            disabled={true}
                        />
                    </div>
                    <label>Reason</label>
                    <RHFTextArea 
                        name={'reason'}
                        register={register} 
                        errors={errors}
                        style={{width: '100%', height: '20rem'}}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default VoidVoucherDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/VoidVoucherDialog.tsx